import { render, staticRenderFns } from "./BottomList.vue?vue&type=template&id=d1d5e388&scoped=true&"
import script from "./BottomList.vue?vue&type=script&lang=js&"
export * from "./BottomList.vue?vue&type=script&lang=js&"
import style0 from "./BottomList.vue?vue&type=style&index=0&id=d1d5e388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d5e388",
  null
  
)

export default component.exports